import { render, staticRenderFns } from "./standard-list.vue?vue&type=template&id=05e0ca9b&scoped=true&"
import script from "./standard-list.vue?vue&type=script&lang=js&"
export * from "./standard-list.vue?vue&type=script&lang=js&"
import style0 from "./standard-list.vue?vue&type=style&index=0&id=05e0ca9b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e0ca9b",
  null
  
)

export default component.exports